import CityPage from '../../components/Pages/CityPage';
import { pages } from '../pageTypes';
import PageWrapper from './PageWrapper';

export default function CityPageWrapper({ serviceId }) {
  const shouldBePage = pages.city;
  const conditionTypes = {
    page: true,
    service: true,
  };

  return (
    <PageWrapper
      pageToLoad={<CityPage />}
      shouldBePage={shouldBePage}
      serviceId={serviceId}
      conditions={conditionTypes}
    />
  );
}
